
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../common/client/components/Text';

const classNames = mergeStyleSets({
    title: {
        color: getTheme().palette.neutralSecondary,
        paddingLeft: 0,
        paddingBottom: 8
    }
});

const PanelSectionTitle = ({title}) => {

    return (
        <Stack.Item className={classNames.title}>
            <Text medium bold>{title}</Text>
        </Stack.Item>
    );
}

export default PanelSectionTitle;
